export default "https://cdn-static-staging.gokick.com/assets/98f5e78fc13494034d6569c4b787741d65d3002e/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";